document.addEventListener('DOMContentLoaded', () => {
  const home = document.querySelector('#red-dust-home');
  if (home) {
    document.documentElement.classList.add('rd-home-page');
    document.body.classList.add('rd-home-active');
  }

  const header = document.querySelector('[data-rd-header]');
  const button = header?.querySelector('[data-rd-menu]');
  const navigation = header?.querySelector('[data-rd-nav]');
  button?.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    navigation?.classList.toggle('is-open', !open);
  });

  navigation?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      button?.setAttribute('aria-expanded', 'false');
      navigation.classList.remove('is-open');
    });
  });
});
